"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.ICON_SIZE = exports.ICON_NAME = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var Icons = _interopRequireWildcard(require("../Icons"));
require("./Icon.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ICON_SIZE = /*#__PURE__*/function (ICON_SIZE) {
  ICON_SIZE["default"] = "default";
  ICON_SIZE["large"] = "large";
  ICON_SIZE["semilarge"] = "semilarge";
  ICON_SIZE["medium"] = "medium";
  ICON_SIZE["small"] = "small";
  ICON_SIZE["xsmall"] = "xsmall";
  return ICON_SIZE;
}(ICON_SIZE || {});
exports.ICON_SIZE = ICON_SIZE;
var ICON_NAME = /*#__PURE__*/function (ICON_NAME) {
  ICON_NAME["account"] = "IconAccount";
  ICON_NAME["alertError"] = "IconAlertError";
  ICON_NAME["alertInfo"] = "IconAlertInfo";
  ICON_NAME["alertNotification"] = "IconAlertNotification";
  ICON_NAME["alertSuccess"] = "IconAlertSuccess";
  ICON_NAME["alertWarning"] = "IconAlertWarning";
  ICON_NAME["arrowDown"] = "IconArrowDown";
  ICON_NAME["arrowLeft"] = "IconArrowLeft";
  ICON_NAME["arrowRight"] = "IconArrowRight";
  ICON_NAME["arrowUp"] = "IconArrowUp";
  ICON_NAME["balance"] = "IconBalance";
  ICON_NAME["boxCheck"] = "IconBoxCheck";
  ICON_NAME["cart"] = "IconCart";
  ICON_NAME["cartOutline"] = "IconCartOutline";
  ICON_NAME["certificate"] = "IconCertificate";
  ICON_NAME["checkmark"] = "IconCheckmark";
  ICON_NAME["checkmarkMixed"] = "IconCheckmarkMixed";
  ICON_NAME["clock"] = "IconClock";
  ICON_NAME["close"] = "IconClose";
  ICON_NAME["codeScanner"] = "IconCodeScanner";
  ICON_NAME["compare"] = "IconCompare";
  ICON_NAME["cookie"] = "IconCookie";
  ICON_NAME["copy"] = "IconCopy";
  ICON_NAME["coreAssortment"] = "IconCoreAssortment";
  ICON_NAME["costCenter"] = "IconCostCenter";
  ICON_NAME["dashboard"] = "IconDashboard";
  ICON_NAME["delivery"] = "IconDelivery";
  ICON_NAME["discount"] = "IconDiscount";
  ICON_NAME["dots"] = "IconDots";
  ICON_NAME["download"] = "IconDownload";
  ICON_NAME["edit"] = "IconEdit";
  ICON_NAME["emailSend"] = "IconEmailSend";
  ICON_NAME["expressOrder"] = "IconExpressOrder";
  ICON_NAME["eyeHide"] = "IconEyeHide";
  ICON_NAME["eyeShow"] = "IconEyeShow";
  ICON_NAME["favorite"] = "IconFavorite";
  ICON_NAME["filter"] = "IconFilter";
  ICON_NAME["fullscreen"] = "IconFullscreen";
  ICON_NAME["fullscreenClose"] = "IconFullscreenClose";
  ICON_NAME["globe"] = "IconGlobe";
  ICON_NAME["house"] = "IconHouse";
  ICON_NAME["infoOutline"] = "IconInfoOutline";
  ICON_NAME["invoice"] = "IconInvoice";
  ICON_NAME["linkExternal"] = "IconLinkExternal";
  ICON_NAME["loader"] = "IconLoader";
  ICON_NAME["location"] = "IconLocation";
  ICON_NAME["lock"] = "IconLock";
  ICON_NAME["mail"] = "IconMail";
  ICON_NAME["menu"] = "IconMenu";
  ICON_NAME["newsletter"] = "IconNewsletter";
  ICON_NAME["pdf"] = "IconPdf";
  ICON_NAME["pdfFile"] = "IconPdfFile";
  ICON_NAME["phone"] = "IconPhone";
  ICON_NAME["plus"] = "IconPlus";
  ICON_NAME["printAndPromo"] = "IconPrintAndPromo";
  ICON_NAME["printer"] = "IconPrinter";
  ICON_NAME["progressDone"] = "IconProgressDone";
  ICON_NAME["progressOngoing"] = "IconProgressOngoing";
  ICON_NAME["quickview"] = "IconQuickview";
  ICON_NAME["rangeEu"] = "IconRangeEu";
  ICON_NAME["remove"] = "IconRemove";
  ICON_NAME["repair"] = "IconRepair";
  ICON_NAME["reportError"] = "IconReportError";
  ICON_NAME["return"] = "IconReturn";
  ICON_NAME["rmaSolid"] = "IconRmaSolid";
  ICON_NAME["rotate"] = "IconRotate";
  ICON_NAME["rotate360"] = "IconRotate360";
  ICON_NAME["search"] = "IconSearch";
  ICON_NAME["share"] = "IconShare";
  ICON_NAME["socialFacebook"] = "IconSocialFacebook";
  ICON_NAME["socialLinkedin"] = "IconSocialLinkedin";
  ICON_NAME["socialTwitter"] = "IconSocialTwitter";
  ICON_NAME["socialYoutube"] = "IconSocialYoutube";
  ICON_NAME["toplink"] = "IconToplink";
  ICON_NAME["user"] = "IconUser";
  ICON_NAME["userGroup"] = "IconUserGroup";
  ICON_NAME["video"] = "IconVideo";
  ICON_NAME["viewList"] = "IconViewList";
  ICON_NAME["viewTable"] = "IconViewTable";
  ICON_NAME["viewTile"] = "IconViewTile";
  ICON_NAME["wallet"] = "IconWallet";
  ICON_NAME["wishlist"] = "IconWishlist";
  ICON_NAME["wishlistAdd"] = "IconWishlistAdd";
  ICON_NAME["wishlistSolid"] = "IconWishlistSolid";
  return ICON_NAME;
}(ICON_NAME || {});
exports.ICON_NAME = ICON_NAME;
var Icon = function Icon(props) {
  var _classNames;
  var Icons = Icon.Icons;
  var className = props.className,
    name = props.name,
    _props$size = props.size,
    size = _props$size === void 0 ? ICON_SIZE["default"] : _props$size;
  var IconComponent = Icons[name];
  if (typeof IconComponent === 'undefined') {
    throw Error('Unknown icon ' + name);
  }
  var rootClassName = (0, _classnames["default"])('cds-Icon', (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "cds-Icon--".concat((0, _upperCaseFirst.upperCaseFirst)(size || '')), size !== ICON_SIZE["default"]), (0, _defineProperty2["default"])(_classNames, "cds-".concat(name), name), _classNames), className);
  return /*#__PURE__*/_react["default"].createElement(IconComponent, (0, _extends2["default"])({}, props, {
    className: rootClassName
  }));
};
exports.Icon = Icon;
Icon.Icons = Icons;
Icon.config = {
  name: ICON_NAME,
  size: ICON_SIZE
};